import { Box, Skeleton } from "@mui/material";

import ProfileCover from "../../assets/images/profile-cover.png";

const HeadingLoader = () => {
  return (
    <Box
      sx={{
        borderRadius: "8px",
        border: "1px solid #EAECF0",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFF",
      }}
    >
      <Box
        sx={{
          height: "145px",
          backgroundImage: `url(${ProfileCover})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
        }}
      />
      <Box sx={{ display: "flex", flexDirection: "column", gap: "32px", padding: "20px 20px 0" }}>
        <Box sx={{ display: "flex", gap: "16px" }}>
          <Box sx={{ position: "relative", width: "110px" }}>
            <Skeleton
              variant="circular"
              width={110}
              height={110}
              sx={{
                position: "absolute",
                bottom: "0",
                left: "0",
                border: "2px solid #FFF",
              }}
            />
          </Box>
          <Box>
            <Skeleton variant="text" width={200} height={28} />
            <Skeleton variant="text" width={150} height={20} />
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: "24px" }}>
          <Skeleton variant="text" width={80} height={24} />
          <Skeleton variant="text" width={80} height={24} />
          <Skeleton variant="text" width={80} height={24} />
        </Box>
      </Box>
    </Box>
  );
};

export default HeadingLoader;
